import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useMetaAdAccountStore = defineStore('metaAdAccountStore', {
  id: 'metaAdAccountStore',
  state: () => ({
    loading: false,
    error: null,
  }),
  getters: {},
  actions: {
    async getFacebookAdAccounts(filters = {}) {
      const {data} = await axios.get('facebook/ad-accounts', {params: filters})

      return data
    },

    async getFacebookAdAccount(externalId, filters = {}) {
      const {data} = await axios.get(`facebook/ad-accounts/${externalId}`, {params: filters})

      return data
    },
  },
})
